import AppHeader from '../components/AppHeader';
import { L } from '../redesign/tokens';

// The frame of every redesigned agent Reports screen (redesign step 4; dev website only, see lib/redesign.js and redesign/reports/ReportsEntry.jsx): the shared header, then the screen.
// The period pills persist within the section (redesign/reports/periodStore.js).
export default function ReportsAgent({ children }) {
  return (
    <div style={{ minHeight: '100vh', background: L.bg, color: L.text, fontFamily: L.sans, display: 'flex', flexDirection: 'column' }}>
      <AppHeader />
      {children}
    </div>
  );
}
